// extracted by mini-css-extract-plugin
module.exports = {"quint-story":"_2iG3i"};